export const ROUTER_NAMES = {
  login: 'Login',
  screening: 'Screening'
}
